import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { FeedbackComponent } from './pages/feedback/feedback.component';
import { TravelComponent } from './pages/travel/overview/travel.component';
import { TravelViewComponent } from './pages/travel/detail/travel-view.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'services',
    loadChildren: () =>
      import('./pages/services/services.module').then((m) => m.ServicesModule),
  },
  {
    path: 'destination/events',
    loadChildren: () =>
      import('./pages/events/events.module').then((m) => m.EventsModule),
  },
  {
    path: 'destination/places',
    loadChildren: () =>
      import('./pages/places/places.module').then((m) => m.PlacesModule),
  },
  {
    path: 'destination',
    loadChildren: () =>
      import('./pages/destination/destination.module').then(
        (m) => m.DestinationModule
      ),
  },
 /* {
    path: 'destination/1',
    loadChildren: () =>
      import('./pages/hotels/hotels.module').then((m) => m.HotelsModule),
  },*/
 /* {
    path: 'destination/2',
    loadChildren: () =>
      import('./pages/travel/travel.module').then((m) => m.TravelModule),
  },*/
  {
    path: 'feedback',
    component: FeedbackComponent,
  },
 /* {
    path: 'destination/3',
    loadChildren: () =>
      import('./pages/restaurants/restaurants.module').then(
        (m) => m.RestaurantsModule
      ),
  },*/
  {
    path: 'blog',
    loadChildren: () =>
      import('./pages/blog/blog.module').then((m) => m.BlogModule),
  },
  {
    path: 'sourvey',
    loadComponent: () =>
      import('./pages/your-opinion/your-opinion.component').then(
        (m) => m.YourOpinionComponent
      ),
  },
  {
    path: 'faqs',
    loadComponent: () =>
      import('./pages/faqs/faqs.component').then((m) => m.FaqsComponent),
  },
  {
    path: 'legal',
    loadComponent: () =>
      import('./pages/legals/legals.component').then((m) => m.LegalsComponent),
  },
  {
    path: 'policies',
    loadComponent: () =>
      import('./pages/policies/policies.component').then(
        (m) => m.PoliciesComponent
      ),
  },
  {
    path: 'hospitality',
    loadComponent: () =>
      import('./pages/hospitality/hospitality.component').then(
        (m) => m.HospitalityComponent
      ),
  },
  {
    path: 'destination/trip',
    loadComponent: () =>
      import('./pages/mytrip/mytrip.component').then((m) => m.MytripComponent),
  },
  {
    path: 'about',
    loadComponent: () =>
      import('./pages/about/about.component').then((m) => m.AboutComponent),
  },
  {
    path: 'not-found',
    pathMatch: 'full',
    component: NotFoundComponent,
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
    /*  {
    path: 'romance',
    loadChildren: () =>
      import('./pages/romance/romance.module').then((m) => m.RomanceModule),
  }, */
/*  {
    path: 'wellness',
    loadChildren: () =>
      import('./pages/welfare/welfare.module').then((m) => m.WelfareModule),
  },*/
   /* {
    path: 'leisure',
    loadChildren: () =>
      import('./pages/leisure/leisure.module').then((m) => m.LeisureModule),
  }, */
  /*  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.component').then((m) => m.LoginComponent),
  }, */
  /*  {
    path: 'dmc',
    loadComponent: () =>
      import('./pages/dmc/dmc.component').then((m) => m.DmcComponent),
  }, */
  /* {
    path: 'incentives',
    loadComponent: () =>
      import('./pages/incentives/incentives.component').then(
        (m) => m.IncentivesComponent
      ),
  }, */
  /* {
    path: 'company',
    loadComponent: () =>
      import('./pages/company/company.component').then(
        (m) => m.CompanyComponent
      ),
  }, */
 /* {
    path: 'contracts',
    loadChildren: () =>
      import('./pages/contracts/contracts.module').then(
        (m) => m.ContractsModule
      ),
  }, */
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
